"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

/**
 * Filter function factory that creates a function to apply the selected
 * filters that can be passed to Array.filter in the context of an array
 * of credit cards obtained from `useCreditCards`. Note that this can only
 * apply a single filter, but can be chained to combine them (AND).
 * @param {object} param
 * @param {string} param.activeFilter       the active filter
 * @param {string} param.activeFilterOption the active filter option
 * @returns {function(*):boolean} the filter function
 */
var _default = function _default() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$activeFilter = _ref.activeFilter,
      activeFilter = _ref$activeFilter === void 0 ? '' : _ref$activeFilter,
      _ref$activeFilterOpti = _ref.activeFilterOption,
      activeFilterOption = _ref$activeFilterOpti === void 0 ? '' : _ref$activeFilterOpti;

  return function (_ref2) {
    var _ref2$tags = _ref2.tags,
        tags = _ref2$tags === void 0 ? [] : _ref2$tags;
    return activeFilterOption ? tags.find(function (tag) {
      return activeFilterOption === tag.value && activeFilter === tag.name;
    }) : activeFilter ? tags.find(function (tag) {
      return activeFilter === tag.name && activeFilter === tag.value;
    }) : true;
  };
};

exports["default"] = _default;
//# sourceMappingURL=create-credit-card-filter.js.map